import React, { useState } from "react";
import { Card, Form, Button, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "../../../interceptor/axios-config";
import config from "../../../config";
import { useGrade } from "../../../context/GradeContext";

const ExamFee = () => {

  const { grade } = useGrade(); // normalized class list

  const [gradeId, setGradeId] = useState("");
  const [selectedSections, setSelectedSections] = useState([]);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  console.log(grade);
  // 🔥 Get available sections dynamically
  const availableSections = gradeId
    ? [...new Set(
        grade
          .filter(c => c.grade_id == gradeId)
          .map(c => c.section_name)
      )]
    : [];

  const toggleSection = (sec) => {
    setSelectedSections(prev =>
      prev.includes(sec)
        ? prev.filter(s => s !== sec)
        : [...prev, sec]
    );
  };

  const handleGradeChange = (e) => {
    const selectedGrade = e.target.value;
    setGradeId(selectedGrade);

    if (selectedGrade) {
      const sectionsForGrade = [
        ...new Set(
          grade
            .filter(c => c.grade_id == selectedGrade)
            .map(c => c.section_name)
        )
      ];
      setSelectedSections(sectionsForGrade); // auto-check all
    } else {
      setSelectedSections([]);
    }
  };

  const generateExamFee = async () => {

    if (!gradeId || !amount) {
      Swal.fire("Error", "Select class and amount", "warning");
      return;
    }

    if (selectedSections.length === 0) {
      Swal.fire("Error", "Select at least one section", "warning");
      return;
    }

    // 🔥 Find matching class_ids
    const selectedClassObjects = grade.filter(
      c =>
        c.grade_id == gradeId &&
        selectedSections.includes(c.section_name)
    );

    const classIds = selectedClassObjects.map(c => c.value);

    const confirm = await Swal.fire({
      title: "Generate Exam Fee?",
      html: `
        <b>Class:</b> Class-${selectedClassObjects[0]?.grade_name}<br/>
        <b>Sections:</b> ${selectedSections.join(", ")}<br/>
        <b>Amount:</b> ₹${amount}
      `,
      showCancelButton: true,
      confirmButtonText: "Generate"
    });

    if (!confirm.isConfirmed) return;

    try {
      setLoading(true);

      const res = await axios.post(
        `${config.apiBaseUrl}/fees/generate-exam-fee.php`,
        {
          class_ids: classIds,
          amount
        }
      );

      if (res.data.success) {
        Swal.fire("Success", res.data.message, "success");
        setAmount("");
      } else {
        Swal.fire("Error", res.data.error, "error");
      }

    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Server error", "error");
    } finally {
      setLoading(false);
    }
  };

  // 🔥 Unique Grades for dropdown
  const uniqueGrades = [...new Map(
    grade.map(c => [c.grade_id, c])
  ).values()];

  return (
    <Card className="p-4">
      <h4 className="mb-3">Exam Fee Generator</h4>

      <Row className="mb-3">

        {/* Grade Dropdown */}
        <Col md={6}>
          <Form.Label>Class</Form.Label>
          <Form.Select
            value={gradeId}
            onChange={handleGradeChange}
          >
            <option value="">Select Class</option>
            {uniqueGrades.map(g => (
              <option key={g.grade_id} value={g.grade_id}>
                {g.grade_name} ({g.academic_year})
                {/* Class-{g.grade_name} ({g.academic_year}) */}
              </option>
            ))}
          </Form.Select>
        </Col>

        {/* Section Checkboxes */}
        <Col md={6}>
          <Form.Label>Sections</Form.Label>

          {!gradeId ? (
            <div className="text-muted">Select class first</div>
          ) : (
            <Row>
              {availableSections.map(sec => (
                <Col md={4} key={sec}>
                  <Form.Check
                    type="checkbox"
                    label={sec}
                    checked={selectedSections.includes(sec)}
                    onChange={() => toggleSection(sec)}
                  />
                </Col>
              ))}
            </Row>
          )}
        </Col>

        {/* Amount */}
        <Col md={12} className="mt-3">
          <Form.Label>Amount</Form.Label>
          <Form.Control
            type="number"
            placeholder="Enter exam fee amount"
            value={amount}
            onChange={e => setAmount(e.target.value)}
          />
        </Col>

      </Row>

      <Button
        variant="primary"
        onClick={generateExamFee}
        disabled={
          loading ||
          !gradeId ||
          selectedSections.length === 0 ||
          !amount
        }
      >
        {loading ? "Generating..." : "Generate Exam Fee"}
      </Button>
    </Card>
  );
};

export default ExamFee;